import React from 'react';
import {Flex, Text} from '@priority-software/priority-style-react';
import styles from './style.module.scss';
import todolistPromoImg from '../../../images/todolist_promo.png';

export const TodoListPromoContent = ({text}) => {
    return (
        <Flex direction="column">
            <img src={todolistPromoImg} alt="ToDoList Promo" className={styles.todolistPromoImg} />
            <Text skin="paragraph-2">{text}</Text>
        </Flex>
    );
};
